import angular from 'angular';
import booksMenu from '../../menu/Menu';
import entitiesAdmin from './entitiesAdmin';

export default angular
  .module('individuals', [booksMenu, entitiesAdmin])
  .factory('EntitiesSvc', entitiesSvcFactory)
  .factory('GroupsSvc', groupSvcFactory)
  .factory('EntitiesAdminService', entitiesAdminServiceFactory)
  .controller('IndividualsController', IndividualsController)
  .config(entitiesConfig)
  .name;

/*****************************************************************************
 * Factory: EntitiesSvc
 *
 * Create singleton EntitiesSvc factory to contain all service calls
 *****************************************************************************/
/* @ngInject */ function entitiesSvcFactory(CSMHttp) {
  return {
    getConfig: function () {
      return CSMHttp.doGet('entitiesAdmin/Services.ashx/getConfig');
    }
  };
}

/*****************************************************************************
 * Factory: GroupsSvc
 *
 * Create singleton GroupsSvc factory to contain all GroupsController service
 * calls.
 *****************************************************************************/
  /* @ngInject */ function groupSvcFactory(CSMHttp) {
  return {
    get: function (entityID, type) {
      return CSMHttp.doPost('books/apps/GroupsController.ashx/get', {
        entityID: entityID,
        type: type
      });
    },
    remove: function (groupID, type) {
      return CSMHttp.doPost(
        'books/apps/GroupsController.ashx/removeGroup',
        { groupID: groupID, type: type }
      );
    }
  }
}

/*******************************************************************************
 * Factory: EntitiesAdminService
 *
 * The singleton that is created will contain a means to load all necessary item
 * data and cache the values for multiple component access.
 *******************************************************************************/
/* @ngInject */ function entitiesAdminServiceFactory($q, SERVER, BooksSvc, BusyScreen, EntityAdminListItem) {
  /*-------*/
  /* Flags */
  /*-------*/
  var initialized = false;

  /*----------------*/
  /* Dataproviders. */
  /*----------------*/
  var mNames = [];
  var mGroups = [];
  var mStatuses = [];

  /*----------------------*/
  /* Reload list methods. */
  /*----------------------*/
  var reloadNames = function () {
    return BooksSvc.viewEntitiesForAdmin().then(function (resp) {
      mNames = resp.data.map(function (e) {
        return new EntityAdminListItem(e);
      });
    });
  };
  var reloadGroups = function () {
    return BooksSvc.getEntityList(
      SERVER.BooksDBConstants.ET_GROUP.toString(),
      null
    ).then(function (resp) {
      mGroups = resp.data.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
    });
  };
  var reloadStatuses = function () {
    return BooksSvc.getTagList(
      SERVER.BooksDBConstants.TT_STATUS.toString()
    ).then(function (resp) {
      mStatuses = resp.data.statusTags;
    });
  };

  /***************************************************************************
   * init */
  /**
   * Initialize the service. Load the lists.
   *
   * @return  Promise  Resolves when lists have been loaded.
   ***************************************************************************/
  var init = function () {
    BusyScreen.setBusy(false);
  };

  /*---------------------------------------------*/
  /* Return an API to interact with the service. */
  /*---------------------------------------------*/
  return {
    init: init,
    getNames: function () {
      return mNames;
    },
    getGroups: function () {
      return mGroups;
    },
    getStatuses: function () {
      return mStatuses;
    },
    reloadNames: reloadNames,
    reloadGroups: reloadGroups,
    reloadStatuses: reloadStatuses
  };
}

/*******************************************************************************
 * Controller: IndividualsController
 *
 * Main controller for the app
 *******************************************************************************/
/* @ngInject */ function IndividualsController($appFlags, $scope, EntitiesSvc) {
  /*----------------------------------------------------------*/
  /* Flag to prevent initialization of the entitiesAdmin      */
  /* directive before flags have been loaded from the server. */
  /*----------------------------------------------------------*/
  $scope.appReady = false;

  /*---------------------------------------*/
  /* Store appFlags on the scope so it can */
  /* be passed to entitiesAdmin directive. */
  /*---------------------------------------*/
  $scope.appFlags = $appFlags;

  EntitiesSvc.getConfig().then(function (resp) {
    /*------------------------------------------------------*/
    /* Get and store product specific flags on the scope so */
    /* they can be passed to the entitiesAdmin directive.   */
    /*------------------------------------------------------*/
    $scope.hideASBCard = resp.data.hideMembershipYear;
    $scope.hideStatuses = resp.data.hideStatuses;
    $scope.includeGrade = resp.data.includeGrade;

    /*---------------*/
    /* Load the app. */
    /*---------------*/
    $scope.appReady = true;
  });
}

/*****************************************************************************
 * Config:
 *
 * Configure Item Admin app routes.
 *****************************************************************************/
/* @ngInject */ function entitiesConfig($routeProvider) {
  /*--------------------------------------------------*/
  /* Upon injection, ensure that the lists are loaded */
  /* before the directive controller is instantiated. */
  /*--------------------------------------------------*/
  var resolve = {
    init: function (EntitiesAdminService) {
      return EntitiesAdminService.init();
    }
  };

  $routeProvider
    .when('/', { template: '<names-entity-content>', resolve: resolve })
    .when('/groups/', {
      template: '<groups-entity-content>',
      resolve: resolve
    })
    .when('/statuses/', {
      template: '<statuses-entity-content>',
      resolve: resolve
    })
    .otherwise({ redirectTo: '/' });
}
